import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-filter"
// Auto-submits the 我的收藏 sort / ongoing-only form on change
export default class extends Controller {
  submit() {
    // A checked box already sends its value; drop its "false" fallback so the URL carries one value
    this.element.querySelectorAll("input[type=checkbox]").forEach((box) => {
      const fallback = this.element.querySelector(`input[type=hidden][name="${box.name}"]`)
      if (fallback) fallback.disabled = box.checked
    })
    this.element.requestSubmit()
  }
}
